/* eslint-disable no-prototype-builtins */
/* eslint-disable func-names */
const {
    calculateFutureValue, supportsPCP, isVehiclePcpEligible, getExtrasPricesForLender,
    MONEYBARN, ADVANTAGE, LENDABLE, ALPHERA, METROBANK, TANDEM,
    BNP, CLOSE, MANNISLAND, MOTONOVO, V12, OODLE,
    CARFINANCE247, LTV_BASELINES,
    CREDITAGRICOLE, NORTHRIDGEFINANCE, CAMCO, PCP_LENDERS,
    LENDERS_TRUNCATE_AND_ROUND_MONTHLY_PAYMENT, LENDERS_INCLUDE_POST_FEES_IN_COST_OF_CREDIT,
    LENDERS_EXCLUDE_DEPOSIT_FROM_TOTAL_AMOUNT_PAYABLE, LENDERS_NO_MONTHLY_PAYMENT_ROUNDING,
    getFixedPrimes, insideRange, getNum, isNullOrUndefined, getPrimeRate,
    calcAPRBisectionMethod, installmentBuilder, calculateEffectiveRate,
    getLendersPreFees, getLendersPostFees, collapse, isntDeclined,
    calculateMonthlyPayment, p, dumpMatrix, vehicleValid, getMaxLTV, getByPath,
    vehicleQualifies, vehicleAgeInMonths, vehicleAge, findBetterEffectiveRates, dp2, MONEYWAY, dealerValid, AUTOMONEY, ZOPA,
    LENDERS_EXCLUDE_CHARGES_FROM_COST_OF_CREDIT, LENDERS_TRUNCATE_MONTHLY_PAYMENT,
    FLAT_RATE_CALC_ROUNDING, LENDERS_EXCLUDE_POST_FEES_FROM_COST_OF_CREDIT_PCP, LENDERS_TERM_ADJUST,
    STARTLINE
} = require('./calculator-constants');

const { constructResidualsRequest } = require('./utility/construct-residuals-request');
const { getResiduals } = require('./utility/get-residuals');

const ProposalHelper = require('./utility/proposal-helper');

const dateLib = require('./datetime');

const { STARTLINE_MAX_LEND_UNDER_21, STARTLINE_MAX_LEND_NOT_EMPLOYED } = require('./constants/startline-rule-constants');
const { EMPLOYMENT_STATUS_ENUM } = require('./enum/occupation');
const { DRIVING_LICENCE_ENUM } = require('./enum/driving-licence');
const { VEHICLE_TYPE_ENUM } = require('./enum/vehicle-type');
const { PRODUCT_TYPE_ENUM } = require('./enum/product-type');
const { LENDERS_NO_WARRANTY_PCP } = require('./config/products');

// Detect if a figure is in months or years and convert to months
function y2m(y) {
    if (y > 23) {
        return y;
    }
    return y * 12;
}

function vehicleMileagePasses(prop, vehicle) {
    let maxMileage = ProposalHelper.getPropMaxMileage(prop, vehicle);
    let minMileage = prop.minMileage ? prop.minMileage : 0;

    if (!maxMileage) {
        return true;
    }

    const passes = vehicle.mileage <= maxMileage && vehicle.mileage >= minMileage;

    if (!passes && !prop.vehicleRuleResults.find((r) => r.rule === "MaxMileage")) {
        prop.vehicleRuleResults.push({
            id: prop.financeCompanyId,
            displayPriority: 1,
            vehicleId: vehicle.vehicleId,
            resultType: "VehicleFailRule",
            rule: vehicle.mileage > maxMileage ? "MaxMileage" : "MinMileage",
            message:
                vehicle.mileage > maxMileage
                    ? `Vehicle exceeds max mileage of ${maxMileage.toLocaleString()} miles`
                    : `Vehicle below min mileage of ${minMileage.toLocaleString()} miles`,
        });
    }

    return passes;
};

function termPasses(vehicle, prop, term) {
    if (Number(term) < Number(prop.minTerm)) {
        prop.vehicleRuleResults.push(
            {
                displayPriority: 1,
                vehicleId: vehicle.vehicleId,
                resultType: "FinanceFailRule",
                term,
                rule: "Term",
                message: `Term ${term} months not supported`
            }
        )
        return false;
    }
    if (Number(term) > Number(prop.maxTerm)) {
        prop.vehicleRuleResults.push(
            {
                displayPriority: 1,
                vehicleId: vehicle.vehicleId,
                resultType: "FinanceFailRule",
                term,
                rule: "Term",
                message: `Term ${term} months not supported`
            }
        )
        return false;
    }
    return true;

}

function loanAmountPasses(prop, extras, vehicle) {
    let { totalLoanAmount, extrasOutPrice } = extras;
    totalLoanAmount += extrasOutPrice;

    const withinLoanAmountLimits = totalLoanAmount >= prop.minLendAmount && totalLoanAmount <= 1000000 ? true : false;

    if (!withinLoanAmountLimits && prop.vehicleRuleResults && !prop.vehicleRuleResults.find(r => r.rule === 'LoanAmount')) {
        prop.vehicleRuleResults.push({
            displayPriority: 3,
            vehicleId: vehicle.vehicleId,
            resultType: "FinanceFailRule",
            rule: "LoanAmount",
            message: totalLoanAmount < prop.minLendAmount ? "Does not meet min lend of &pound;" + prop.minLendAmount.toLocaleString() : totalLoanAmount > 1000000 ? "Exceeds max lend of &pound;1,000,000" : ""
        })
    }

    return withinLoanAmountLimits;
};

function vehicleAgePasses(prop, vehicle, term, log = false) {
    const ageInMonths = vehicleAgeInMonths(vehicle);
    const ageAtEnd = ageInMonths + getNum(term);

    if (ageInMonths > 0) {
        let maxVehicleAgeAtEnd = ProposalHelper.getPropMaxVehicleAgeAtEnd(prop, vehicle);

        // Are there age at end of term rules
        if (getNum(maxVehicleAgeAtEnd) > 0) {
            if (ageAtEnd >= y2m(getNum(maxVehicleAgeAtEnd))) {
                if (log && prop.vehicleRuleResults) {
                    prop.vehicleRuleResults.push({
                        displayPriority: 2,
                        vehicleId: vehicle.vehicleId,
                        resultType: "FinanceFailRule",
                        term,
                        message: "Vehicle age at end of term"
                    })
                }

                return false;
            }
        }

        // Deal with null inputs, scaled ends up at 0 not null .. grr
        let minAAS = prop.minVehicleAgeAtStart;
        let maxAAS = prop.maxVehicleAgeAtStart;

        if (minAAS != null) {
            minAAS = y2m(getNum(minAAS));
        }
        if (maxAAS != null) {
            maxAAS = y2m(getNum(maxAAS));
        }

        const result = insideRange(minAAS, maxAAS, ageInMonths, 'age of vehicle at start');

        if (!result && log && prop.vehicleRuleResults) {
            prop.vehicleRuleResults.push({
                id: prop.financeCompanyId,
                displayPriority: 2,
                vehicleId: vehicle.vehicleId,
                resultType: "VehicleFailRule",
                message: "Vehicle age"
            })
        }
        return result;
    }

    return true;
};

/**
 * Apply the age restrictions for customers
 * @param {*} prop the proposal
 * @param {*} customer the customer object
 * @param {*} term the proposed term
 * @returns true if passes, false if not
 */
function customerAgePasses(prop, customer, term) {
    // Check the object for require params
    if (customer != null && customer.hasOwnProperty('dateOfBirth') && prop.hasOwnProperty('maxCustomerAgeAtEnd')) {
        const customerDateOfBirth = customer.dateOfBirth;
        if (!isNullOrUndefined(customerDateOfBirth) && getNum(prop.maxCustomerAgeAtEnd) > 0) {
            const agreementEndDate = new Date();
            agreementEndDate.setMonth(agreementEndDate.getMonth() + term);

            const customerAgeAtEndOfAgreement = dateLib.getYearsBetween(agreementEndDate, customerDateOfBirth);
            return customerAgeAtEndOfAgreement <= prop.maxCustomerAgeAtEnd;
        }
    }
    return true;
};

//If customer has provisional license for credit agricole, should only qualify for motorbike.
function isVehicleSupportedforProvisionalLicence(prop, vehicle, customer) {
    if (prop.financeCompanyId !== CREDITAGRICOLE) {
        return true;

    }
    if (customer && customer.drivingLicenseType != null && customer.drivingLicenseType.drivingLicenseTypeId === DRIVING_LICENCE_ENUM.PROVISIONAL_UK
        && (vehicle.vehicleType == VEHICLE_TYPE_ENUM.CAR || vehicle.vehicleType == VEHICLE_TYPE_ENUM.VAN)) {
        console.error("Excluding Credit Agricole proposal when buying a car or van when customer licence type is Provisional UK Driving Licence.");
        return false;
    }
    else {
        return true;
    }
}

/**
 * Extract the appropriate future value from the car if it exists, or default to the
 * DG special function which we've ran on for 1 year!
 * @param {*} vehicle
 * @param {*} financeCompanyId
 * @param {*} term
 * @param {*} pcpMileage
 */
function getFutureValue(vehicle, financeCompanyId, term, pcpMileage) {
    if (financeCompanyId > 0) {
        // If we've passed it in on the vehicle
        if (vehicle.futureValueAtThisTerm && vehicle.futureValueAtThisTerm > 0) {
            return vehicle.futureValueAtThisTerm;
        }
        // Do we have a matrix of prices / terms
        if (vehicle.futures && vehicle.futures[financeCompanyId]) {
            const fv = getByPath(vehicle.futures, [financeCompanyId, term]);
            if (fv > 0) {
                return fv;
            }
        }
    }

    if (financeCompanyId === CARFINANCE247) { // for cf247 proposals (mocked) use an estimated future value
        return calculateFutureValue(vehicle.make, vehicle.model, vehicle.price, vehicleAge(vehicle), term, pcpMileage);
    }

    return null;
};

// PCP Calculator
function calculatePcpMonthlyPayment(vehicle, totalPrice, term, deposit = 0, rate = 0, prop = null, pcpMileage = 8000, customer = null, bespokeRates = null) {

    if (!prop) {
        return null;
    }

    const fv = getFutureValue(vehicle, prop.financeCompanyId, term, pcpMileage);
    // Do not calculate if we don't have a future value
    if (!fv) {
        prop.vehicleRuleResults.push(
            {
                displayPriority: 5,
                vehicleId: vehicle.vehicleId,
                resultType: "FinanceFailRule",
                pcp: true,
                term,
                rule: "Term",
                message: `Unable to get residual value for ${term} months`
            }
        )
        return null;
    }

    // What will the final payment be
    const futureValue = Math.round(100.0 * fv) / 100.0;

    // Effective Deposit
    const loanAmount = totalPrice - deposit;

    const lendersPostFees = getLendersPostFees(prop.financeCompanyId);

    // Balloon as fraction of vehicle price (for forumula)
    const x = (futureValue + lendersPostFees) / (loanAmount);

    const apr = rate > 0 ? rate : getPrimeRate(loanAmount, vehicleAgeInMonths(vehicle), customer, bespokeRates, prop.financeCompanyId, true);
    const aprPercentage = getNum(apr) / 100.00;
    const aprPercentagePlusOne = aprPercentage + 1;

    let preTermAdjust = 0;
    let postTermAdjust = 1;

    let lta = LENDERS_TERM_ADJUST.find(f => f.financeCompanyId === prop.financeCompanyId && f.pcp === true);

    if (lta) {
        preTermAdjust = lta.adjust;
        postTermAdjust = lta.adjust - 1;
    }

    // eslint-disable-next-line no-restricted-properties
    let monthlyInterestRate = Math.pow(aprPercentagePlusOne, (1.0000 / 12.0000)) - 1;

    // eslint-disable-next-line no-restricted-properties
    const mpot = Math.pow((1.0 + monthlyInterestRate), term + preTermAdjust);
    const mpotratio = (mpot - x) / mpot;

    let numerator = monthlyInterestRate * ((loanAmount * mpotratio));

    // eslint-disable-next-line no-restricted-properties
    let denominator = (1 - Math.pow(1 / (1 + monthlyInterestRate), term - postTermAdjust));

    let monthlyPayment = Math.round(100.0 * numerator / denominator) / 100.0;

    const truncate = prop ? LENDERS_TRUNCATE_MONTHLY_PAYMENT.find(v => v === prop.financeCompanyId) : false;
    const truncateAndRoundMonthlyPayment = prop ? LENDERS_TRUNCATE_AND_ROUND_MONTHLY_PAYMENT.find(v => v === prop.financeCompanyId) : false;

    // console.log("PCP Innards", loanAmount, vehicle.price, futureValue, deposit, apr, numerator, denominator, monthlyInterestRate);

    const mpxterm = dp2(getNum(p(monthlyPayment)) * getNum(term - postTermAdjust), 2)
    let tot = mpxterm + getNum(futureValue) + getNum(deposit) + lendersPostFees;
    let cost = Math.round(100 * (tot - deposit - loanAmount)) / 100.0;

    if (truncateAndRoundMonthlyPayment) {
        monthlyPayment = dp2(monthlyPayment, 2)
        tot = dp2(tot, 2)
    }

    if (LENDERS_EXCLUDE_POST_FEES_FROM_COST_OF_CREDIT_PCP.includes(prop.financeCompanyId)) {
        cost -= lendersPostFees;
    }

    // Result object
    const result = {
        monthlyPayment,
        firstMonthlyPayment: monthlyPayment,
        minDeposit: deposit,
        deposit,
        depositRequired: true,
        finalPayment: futureValue + lendersPostFees,
        totalAmountPayable: tot,
        apr,
        effectiveRate: apr,
        lendersPreFees: 0,
        isPCP: true,
        amountToFinance: loanAmount,
        costOfCredit: cost,
        futureValue,
        termDisplay: term - postTermAdjust,
        lendersPostFees,
        commissionAmount: -1,
    };

    // Check and Santise
    if (result.monthlyPayment <= 0) {
        return null;
    }

    return result;
};

// Simple flat rate, returning total and monthly
/**
 *
 * @param {*} vehiclePrice
 * @param {*} flatRate  the flat rate, not an APR
 * @param {*} term
 * @param {*} deposit
 * @param {*} lendersPostFees
 * @param {*} lendersPreFees
 * @param {*} bisect  which method to use to determine the effective rate
 * @param {*} lendersCharges  any fees that are added to the first monthly payment that do NOT accrue interest
 * @returns the object containing the usual results
 */
function calculateMonthlyPaymentFlat(
    vehiclePrice,
    flatRate,
    term,
    deposit = 0,
    prop
) {
    if (vehiclePrice && flatRate && term) {
        // console.log("flat", prop.financeCompanyId)
        const lendersPreFees = getLendersPreFees(prop.financeCompanyId);
        const lendersPostFees = getLendersPostFees(prop.financeCompanyId);

        let lendersCharges = 0.0;

        const financeCompanyId = prop ? prop.financeCompanyId : null;

        // Oodle first payment fees
        if (financeCompanyId === OODLE) {
            lendersCharges = 50.0;
        }
        // Automoney upfront fee
        if (financeCompanyId === AUTOMONEY) {
            lendersCharges = 199.0;
        }

        // console.log('Calculating Monthly Payment from Flat Rate', financeCompanyId, flatRate, term);
        // console.log("charges", lendersPostFees, lendersPreFees, lendersCharges)
        // This flags an alternative means of calculating the flat effective rate
        // that Advantage only use. It is also (abused) to determine the type of
        // rounding that Advantage do, which is to 5 significant figures on the
        // total, then let the calculations fall through
        const bisect = (financeCompanyId === ADVANTAGE);
        const places = 2;

        const loanAmount = (getNum(vehiclePrice) - getNum(deposit));
        if (loanAmount > 0) {
            const total = (loanAmount + ((flatRate * loanAmount * term) / (1200.00)) + getNum(lendersPreFees));

            // Return object, it will be assigned to destination - normal rounding
            let pcm = LENDERS_NO_MONTHLY_PAYMENT_ROUNDING.includes(financeCompanyId)
                ? total / getNum(term)
                : dp2(total / getNum(term), 2);

            // Advantage round up obviously
            if (financeCompanyId === ADVANTAGE) {
                pcm = Math.ceil(100.0 * (total / term)) / 100.0;
            }
            // And moneyway down
            if (financeCompanyId === MONEYWAY || financeCompanyId === AUTOMONEY) {
                pcm = Math.floor(100.0 * (total / term)) / 100.0;
            }
            const finalPayment = getNum(lendersPostFees) > 0.0 ? dp2(pcm + getNum(lendersPostFees)) : pcm;
            let tot = dp2((pcm * term) + getNum(lendersPostFees) + getNum(deposit) + lendersCharges, places);
            let cost = (tot - (loanAmount) - getNum(deposit) - lendersPostFees);

            if (LENDERS_EXCLUDE_CHARGES_FROM_COST_OF_CREDIT.includes(financeCompanyId)) {
                cost -= lendersCharges
            }
            if (LENDERS_INCLUDE_POST_FEES_IN_COST_OF_CREDIT.includes(financeCompanyId)) {
                cost += lendersPostFees
            }
            if (LENDERS_EXCLUDE_DEPOSIT_FROM_TOTAL_AMOUNT_PAYABLE.includes(financeCompanyId)) {
                tot -= getNum(deposit)
            }

            let effectiveRate = 0;

            // The advantage method
            if ([ADVANTAGE, AUTOMONEY].includes(financeCompanyId)) {
                const dpConfig = FLAT_RATE_CALC_ROUNDING.find(f => f.financeCompanyId === financeCompanyId);
                const dp = dpConfig ? dpConfig.dp : 2;
                const inst = installmentBuilder(pcm, term, pcm + getNum(lendersCharges), pcm + getNum(lendersPostFees));
                effectiveRate = Number((100.0 * calcAPRBisectionMethod([loanAmount], inst, dp)).toFixed(dp));
            }
            else {
                // We must add all fees (effectively first and last monthly payments into the amount being used to determine the effective rate)
                const averagePricePerMonth = ((term * pcm) + lendersPostFees + lendersCharges) / term;
                effectiveRate = calculateEffectiveRate(getNum(vehiclePrice) - getNum(deposit) + lendersPreFees, flatRate, averagePricePerMonth, term);
            }

            // Rounding Logic
            let dp = 1;
            const DP2s = [ADVANTAGE, LENDABLE, TANDEM]; //TODO put with all other constants
            if (DP2s.includes(financeCompanyId)) {
                dp = 2;
            }
            effectiveRate = dp2(effectiveRate, dp);

            return {
                monthlyPayment: pcm,
                firstMonthlyPayment: dp2(pcm + lendersCharges, places),
                finalPayment,
                totalAmountPayable: tot,
                flatRate,
                effectiveRate,
                amountToFinance: loanAmount,
                costOfCredit: dp2(cost, places),
                lendersPreFees,
                lendersPostFees,
                lendersCharges,
                loanAmount,
                tot,
                total,
                termDisplay: term,
                commissionAmount: -1,
            };
        }
    }
    return null;
};

function findMaxTerms(vehicle, activeProposals) {
    const maxByFinCo = {};
    for (let exterm = 60; exterm > 12; exterm -= 1) {
        // eslint-disable-next-line no-restricted-syntax
        for (const prop of activeProposals) {
            // Is it inside the min and max
            if (insideRange(prop.minTerm, prop.maxTerm, exterm, 'term')
                && vehicleAgePasses(prop, vehicle, exterm)) {
                if (!maxByFinCo.hasOwnProperty(prop.financeCompanyId)) {
                    // console.log('Prop', prop.financeCompany, ' has max term ', exterm );
                    maxByFinCo[prop.financeCompanyId] = exterm;
                }
            }
        }
    }
    return maxByFinCo;
};

/**
 * Price Sorting funciton - V1 for preferred tiers
 * @param {*} a
 * @param {*} b
 * @returns number influcencing sort order
 */
function priceSortingFunction(a, b) {
    const topTier = [CARFINANCE247, ALPHERA, MANNISLAND, METROBANK, V12, CLOSE, BNP, MOTONOVO];
    const slaTiersIds = [247, 167, 168];

    // sort by Effective APR
    if (a.effectiveRate > 0 && b.effectiveRate > 0) {
        if (a.effectiveRate != b.effectiveRate) {
            return a.effectiveRate - b.effectiveRate;
        }
        if (a.commissionAmount > 0 && b.commissionAmount > 0) {
            if (b.commissionAmount != a.commissionAmount) {
                return b.commissionAmount - a.commissionAmount;
            }
        }
        if (a.affiliateCommissionAmount > 0 && b.affiliateCommissionAmount > 0) {
            if (b.affiliateCommissionAmount != a.affiliateCommissionAmount) {
                return b.affiliateCommissionAmount - a.affiliateCommissionAmount;
            }
        }
        return a.monthlyPayment - b.monthlyPayment;
    }

    // Both Prime Lenders - sort by monthly
    if (topTier.includes(a.financeCompanyId) && topTier.includes(b.financeCompanyId)) {
        // Include Ranking if possible
        if (a.rank > 0 && b.rank > 0 && a.rank !== b.rank) {
            return a.rank - b.rank;
        }
        return a.deposit !== b.deposit ? a.effectiveRate - b.effectiveRate : a.monthlyPayment - b.monthlyPayment;
    }

    // First prime - deffo negative
    if (topTier.includes(a.financeCompanyId)) {
        return -0.005;
    }

    // Second prime - deffo positive
    if (topTier.includes(b.financeCompanyId)) {
        return 0.005;
    }

    // By now, none of them are prime. So, is A or B in slaTiers - either and monthly payment best
    if (slaTiersIds.includes(a.tierId) && slaTiersIds.includes(b.tierId)) {
        return a.monthlyPayment - b.monthlyPayment;
    }


    // Then that - is a lender offering better service
    if (slaTiersIds.includes(a.tierId)) {
        return -0.01;
    }

    // Or is the other lender offering better service
    if (slaTiersIds.includes(b.tierId)) {
        return 0.01;
    }

    // Otherwise, it's just pcm diff
    return a.deposit !== b.deposit ? a.effectiveRate - b.effectiveRate : a.monthlyPayment - b.monthlyPayment;
};

/** Wrapper function which extracts relevant informaiton from proposals, vehicle and returns an
 * accurate price on the vehicle of interest.
 * @param {*} vehicle - the vehicle (typically a search result, will be mutated)
 * @param {*} activeProposals - the list of active proposals for the customer
 * @param {*} customerDeposit - customer adding a deposit
 * @param {*} pxValue - customer part exchange, is just added to deposit
 * @param {*} customer - the customer details to filter some lender offers
 * @param {*} options - a set of options for the proposal, annualMileage (number), explodePrime (true), occupationStatusId (number)
 */
function calculateMonthlyPaymentForVehicle(vehicle, activeProposals, customerDeposit = 0, pxValue = 0, customer = null, options = {}) {
    // console.log("Pricing ", vehicle.make, vehicle.model, vehicle.price, "with deposit", customerDeposit);
    // We reset every vehicle to the defaults here

    const pxSettlement = options.pxSettlement ? options.pxSettlement : 0;

    // force potential strings to number
    vehicle.price = getNum(vehicle.price);
    vehicle.mileage = getNum(vehicle.mileage);

    vehicle.noMatchingProposal = true;
    vehicle.displayPrices = false;
    vehicle.monthlyPayment = 0;
    vehicle.deposit = 0;
    vehicle.pxValue = pxValue;
    vehicle.pxSettlement = pxSettlement;
    vehicle.minDeposit = 0;
    vehicle.maxDeposit = vehicle.price - 2500;
    vehicle.totalAmountPayable = 0;
    vehicle.effectiveDeposit = 0;
    vehicle.depositRequired = false;
    vehicle.handlingFee = 0;
    vehicle.pcpMatrix = []
    vehicle.pcp = null;
    vehicle.priceMatrix = [];

    vehicle.cannotPrice = false;
    vehicle.cannotPriceReason = null;

    vehicle.cannotPricePCP = false;
    vehicle.cannotPriceReasonPCP = null;

    vehicle.cannotPriceReasons = [];
    vehicle.lenderDecisions = [];

    activeProposals.forEach(p => {
        p.vehicleRuleResults = [];
    })

    const effectiveDeposit = getNum(customerDeposit) + getNum(pxValue) - getNum(pxSettlement);

    // FIX the lenderId/financeCompany ID thing
    // eslint-disable-next-line no-restricted-syntax
    for (const pfix of activeProposals) {
        if (isNullOrUndefined(pfix.financeCompanyId) && !isNullOrUndefined(pfix.lenderId)) {
            pfix.financeCompanyId = pfix.lenderId;
            pfix.financeCompany = pfix.lenderName;
        }
    }

    // So we can not be limited to '6m' terms. We need to find the odd terms that capture max
    // given the vehicle age. PER PROPOSAL.
    const maxTerms = findMaxTerms(vehicle, activeProposals);

    if (vehicle && activeProposals && activeProposals.length > 0) {
        // console.log('Pricing', vehicle.make, vehicle.model, vehicle.price, 'across', activeProposals.length, 'lenders');
        // We will evaluate the prices across all terms in the "Normal" set.
        let terms = [
            12,
            18,
            24,
            30,
            36,
            42,
            48,
            54,
            60,
        ];

        if (options.terms) {
            // eslint-disable-next-line prefer-destructuring
            terms = options.terms;
        } else {
            // Add them in
            // eslint-disable-next-line no-restricted-syntax
            for (const exterm of Object.values(maxTerms)) {
                if (!terms.includes(exterm)) {
                    terms.push(exterm);
                }
            }
        }

        terms.sort();

        // % overage on range to manifest as deposit
        // const OVERAGE_FACTOR = 1.00;

        // the return matrix
        let minPrices = [];
        const pcpPrices = [];

        // eslint-disable-next-line no-restricted-syntax
        for (const term of terms) {
            const vprices = [];

            let newSelectedProposals = activeProposals;

            // Here we remove the CF247 pseudo approval and replace with a full suite of Prime
            // HP approvals, with the PCP overrides taken care of.
            if (options && options.explodePrime) {
                newSelectedProposals = newSelectedProposals.filter(pp => pp.financeCompanyId !== CARFINANCE247);
                newSelectedProposals.push(...getFixedPrimes());
                // console.log('After exploding primes', newSelectedProposals);
            }

            // This is used to determine who to filter out
            const loanAmountPre = (Number(vehicle.price) + vehicle.handlingFee) - getNum(effectiveDeposit);

            // Filter out qualifying proposals
            // eslint-disable-next-line no-loop-func
            newSelectedProposals = newSelectedProposals.filter(prop => prop.financeCompanyId === CARFINANCE247 || (true
                && termPasses(vehicle, prop, term)
                && vehicleMileagePasses(prop, vehicle)
                && loanAmountPasses(prop, getExtrasPricesForLender(vehicle, loanAmountPre, prop.financeCompanyId, options), vehicle)
                && vehicleAgePasses(prop, vehicle, term, true)
                && vehicleValid(prop, vehicle)
                && customerAgePasses(prop, customer, term)
                && isVehicleSupportedforProvisionalLicence(prop, vehicle, customer)
                && isntDeclined(prop)
                && dealerValid(vehicle, prop)
            ));

            // if (newSelectedProposals.length == 0) {
            //  console.warn('[No matching proposal for this vehicle]');
            // }
            newSelectedProposals.forEach(p => {
                if (!p.vehicleRuleResults) {
                    p.vehicleRuleResults = [];
                }
            });

            // eslint-disable-next-line no-restricted-syntax
            for (const prop of newSelectedProposals) {
                // Need a mutable loanAmount
                let loanAmount = (Number(vehicle.price) + vehicle.handlingFee) - getNum(effectiveDeposit);
                let loanAmountPCP = (Number(vehicle.price) + vehicle.handlingFee) - getNum(effectiveDeposit);

                // quotes api doesn't return this - override
                if (prop.financeCompanyId === CARFINANCE247) {
                    prop.maxLendAmount = prop.maxLendAmount ? prop.maxLendAmount : 200000;
                    prop.minLendAmount = prop.minLendAmount ? prop.minLendAmount : 2500;
                    prop.maxTerm = 60;
                    prop.minTerm = 12;
                }
                const vprice = {
                    proposalId: prop.proposalId,
                    noMatchingProposal: false,
                    displayPrices: true,
                    term,
                    financeCompany: prop.financeCompany,
                    financeCompanyId: prop.financeCompanyId,
                    tierId: prop.tierId,
                    tierName: prop.tierName,
                    minDeposit: 0,
                    maxDeposit: vehicle.price - prop.minLendAmount,
                    isPCP: false,
                    pcpMileage: options.pcpMileage ? options.pcpMileage : 0.0,
                    excessMilage: 6.9,
                    rank: 0,
                    loanProposalStatus: prop.loanProposalStatus,
                    cashRequired: 0, // to account for out of 'agreement entirely' warranty and or paint
                };


                const vpricePCP = {
                    proposalId: prop.proposalId,
                    noMatchingProposal: false,
                    displayPrices: true,
                    term,
                    financeCompany: prop.financeCompany,
                    financeCompanyId: prop.financeCompanyId,
                    tierId: prop.tierId,
                    tierName: prop.tierName,
                    minDeposit: 0,
                    maxDeposit: vehicle.price - prop.minLendAmount,
                    isPCP: true,
                    pcpMileage: options.pcpMileage ? options.pcpMileage : 0.0,
                    excessMilage: 6.9,
                    rank: 0,
                    loanProposalStatus: prop.loanProposalStatus,
                    cashRequired: 0, // to account for out of 'agreement entirely' warranty and or paint
                    annualMileageLimit: options.annualMileage ? options.annualMileage : 8000,
                };
                // Have we included a warranty
                let {
                    warrantyPrice,
                    paintPrice,
                    cosmeticRepairPrice,
                    extrasInPrice,
                    extrasInPricePCP,
                    extrasOutPrice,
                    extrasOutPricePCP,
                    extrasCashRequired,
                    extrasCashRequiredPCP,
                    totalLoanAmount,
                    totalLoanAmountPCP
                } = getExtrasPricesForLender(vehicle, loanAmount, prop.financeCompanyId, options);

                if (warrantyPrice) {
                    vprice.warrantyPrice = warrantyPrice;
                    vpricePCP.warrantyPrice = warrantyPrice;
                }
                if (paintPrice) {
                    vprice.paintPrice = paintPrice;
                    vpricePCP.paintPrice = paintPrice;
                }
                if (cosmeticRepairPrice) {
                    vprice.cosmeticRepairPrice = cosmeticRepairPrice;
                    vpricePCP.cosmeticRepairPrice = cosmeticRepairPrice;
                }

                vprice.cashRequired += extrasCashRequired;
                vpricePCP.cashRequired += extrasCashRequiredPCP;

                // Increase the amount being asked to borrow (which is vehicle.price - deposit + extras)
                loanAmount = totalLoanAmount;
                loanAmountPCP = totalLoanAmountPCP;

                // console.log('Lender', prop.financeCompany, prop.apr, prop.flatRate, prop);

                // Default to priceOfCar + extras
                let maxPrice = vehicle.price + extrasInPrice;
                let maxPricePCP = vehicle.price + extrasInPricePCP;
                let maxLTV = null;
                let maxLTVPCP = null;
                let depositRequired = false;
                let depositRequiredPCP = false;

                if (options.ignoreLTV === undefined || options.ignoreLTV === null || options.ignoreLTV === false) {
                    let ltvPrice = vehicle.glassesRetailValuation;

                    let baseline = LTV_BASELINES.find(l => l.financeCompanies.find(fc => fc === prop.financeCompanyId));

                    baseline = baseline ? baseline : { id: 0 };

                    switch (baseline.id) {
                        case 1:
                            if (vehicle.glassesRetailTransacted > 0) {
                                ltvPrice = vehicle.glassesRetailTransacted;
                            }
                            break;
                        case 2:
                            if (vehicle.glassesTradeValuation > 0) {
                                ltvPrice = vehicle.glassesTradeValuation;
                            }
                            break;
                        case 3:
                            if (vehicle.capRetail > 0) {
                                ltvPrice = vehicle.capRetail;
                            }
                            break;
                        case 4:
                            if (vehicle.capClear > 0) {
                                ltvPrice = vehicle.capClear;
                            }
                            break;
                    }

                    if (!isNullOrUndefined(ltvPrice) && ltvPrice > 0) {
                        // HP
                        maxLTV = getMaxLTV(
                            ltvPrice,
                            prop.financeCompanyId,
                            prop.tierId,
                            PRODUCT_TYPE_ENUM.HP,
                            vehicle.condition ? vehicle.condition : 0,
                            vehicle.vehicleType ? vehicle.vehicleType : 0
                        );
                        maxPrice = Math.round(100.0 * maxLTV) / 100.0;
                        // PCP
                        maxLTVPCP = getMaxLTV(
                            ltvPrice,
                            prop.financeCompanyId,
                            prop.tierId,
                            PRODUCT_TYPE_ENUM.PCP,
                            vehicle.condition ? vehicle.condition : 0,
                            vehicle.vehicleType ? vehicle.vehicleType : 0
                        );
                        maxPricePCP = Math.round(100.0 * maxLTVPCP) / 100.0;
                    }
                }

                // Zopa max lend rules
                if (prop.financeCompanyId === ZOPA) {
                    if (vehicleAgeInMonths(vehicle) > prop.maxVehicleAgeMaxLendReducedHp || vehicle.mileage > prop.maxMileageMaxLendReducedHp) {
                        maxPrice = prop.maxLendMileage100KVehicleAge8Hp;
                        maxPricePCP = prop.maxLendMileage100KVehicleAge8Pcp;
                    }

                    if (customer != null && customer.hasOwnProperty('dateOfBirth')) {
                        const customerAge = dateLib.getAgeFromDob(customer.dateOfBirth);
                        if (!isNullOrUndefined(customerAge)) {
                            if (customerAge < prop.minAgeMaxLendReduced) {
                                maxPrice = prop.maxLendCustomerUnder26;
                                maxPricePCP = prop.maxLendCustomerUnder26;
                            }
                        }
                    }
                }

                // Startline Max Lend rules
                if (prop.financeCompanyId === STARTLINE) {
                    // If customer is under 21, then limit max lend
                    if (customer != null && customer.hasOwnProperty('dateOfBirth')) {
                        const customerAge = dateLib.getAgeFromDob(customer.dateOfBirth);
                        if (!isNullOrUndefined(customerAge) && customerAge < 21) {
                            maxPrice = STARTLINE_MAX_LEND_UNDER_21;
                            maxPricePCP = STARTLINE_MAX_LEND_UNDER_21;
                        }
                    }

                    // If customer is 'Not Employed', then limit max lend
                    if (options != null && options.hasOwnProperty('occupationStatusId')) {
                        if (options.occupationStatusId === EMPLOYMENT_STATUS_ENUM.NOT_EMPLOYED) {
                            maxPrice = STARTLINE_MAX_LEND_NOT_EMPLOYED;
                            maxPricePCP = STARTLINE_MAX_LEND_NOT_EMPLOYED;
                        }
                    }
                }

                if (prop.maxLendAmount < maxPrice) {
                    maxPrice = prop.maxLendAmount;
                }


                if (prop.maxLendAmount < maxPricePCP) {
                    maxPricePCP = prop.maxLendAmount;
                }

                // Now determine the minimum depositrs, which are mostly LTV based from above, but
                // there are warranty and specific lender rules also
                vprice.maxDeposit = maxPrice - prop.minLendAmount;
                vpricePCP.maxDeposit = maxPricePCP - prop.minLendAmount;
                // Right, is the total lend (minus any deposit) greater than allowed? This is the
                // primary deposit requirement, the rest must check
                if ((vehicle.price + extrasInPrice) > maxPrice) {
                    vprice.minDeposit = (vehicle.price + extrasInPrice) - maxPrice;
                }

                if ((vehicle.price + extrasInPricePCP) > maxPricePCP) {
                    vpricePCP.minDeposit = (vehicle.price + extrasInPricePCP) - maxPricePCP;
                }

                // Moneybarn only have min deposit at present on Tier 3
                if (prop.financeCompanyId === MONEYBARN && (prop.tierId === 67 || prop.tierId === 119)) {
                    const MIN_MONEYBARN_DEPOSIT_T3 = 400;
                    if (vprice.minDeposit < MIN_MONEYBARN_DEPOSIT_T3) {
                        vprice.minDeposit = MIN_MONEYBARN_DEPOSIT_T3;
                    }
                }

                // Lendable min deposit of 5% - NOW DISABLED
                if (false && prop.financeCompanyId === LENDABLE) {
                    const LENDABLE_MIN = 0.05 * vehicle.price;
                    if (vprice.minDeposit < LENDABLE_MIN) {
                        vprice.minDeposit = LENDABLE_MIN;
                    }
                }

                // Final catch for just extras causing deposit requirements
                if (vprice.minDeposit < extrasOutPrice) {
                    vprice.minDeposit = extrasOutPrice;
                }
                if (vpricePCP.minDeposit < extrasOutPricePCP) {
                    vpricePCP.minDeposit = extrasOutPricePCP;
                }


                let deposit = effectiveDeposit;
                let depositPCP = effectiveDeposit;


                if (vprice.minDeposit > 0) {
                    depositRequired = true;
                }
                if (vpricePCP.minDeposit > 0) {
                    depositRequiredPCP = true;
                }

                // Any negative equity on the deposit
                if (effectiveDeposit < 0) {
                    //
                }
                else {
                    if (effectiveDeposit < vprice.minDeposit) {
                        deposit = vprice.minDeposit;
                    }
                    if (effectiveDeposit < vpricePCP.minDeposit) {
                        depositPCP = vpricePCP.minDeposit;
                    }
                }

                // console.log('Min Deposit', vprice.minDeposit, effectiveDeposit, deposit);


                // The follow affect subsequent calculations
                const hasRate = (getNum(prop.apr) > 0 || getNum(prop.flatRate) > 0);
                let hasTerm = getNum(term) > 0;

                if (prop.financeCompanyId === ADVANTAGE) {
                    if (loanAmount < 6000.0 && term > 54) {
                        hasTerm = false; // This will skip
                    }
                }

                if (prop.financeCompanyId === METROBANK) {
                    if (getNum(term) % 6 !== 0) {
                        hasTerm = false; // This will skip, METRO only support 6m intervals
                    }
                }

                const pcpLender = supportsPCP(prop.financeCompanyId)
                // Can we do the calculation?
                if (hasRate && hasTerm) {
                    const actualLoanAmount = vehicle.price + getNum(extrasInPrice) + getNum(extrasOutPrice) - getNum(deposit);
                    const actualLoanAmountPCP = vehicle.price + getNum(extrasInPricePCP) + getNum(extrasOutPricePCP) - getNum(depositPCP);

                    const qualifies = vehicleQualifies(prop, vehicle, actualLoanAmount, term, options, deposit, false);
                    const qualifiesPCP = pcpLender && vehicleQualifies(prop, vehicle, actualLoanAmountPCP, term, options, depositPCP, true);

                    if (!pcpLender) {
                        prop.vehicleRuleResults.push({
                            vehicleId: vehicle.vehicleId,
                            term,
                            resultType: 'FinanceFailRule',
                            displayPriority: 1,
                            pcp: true,
                            message: 'PCP not supported'
                        })
                    }
                    // Apply APR/FlatRate based on Advance & RnScore (rnScore part is done in QuotesApi)
                    if (prop.hpAprRangesV4) {
                        if (Array.isArray(prop.hpAprRangesV4) && prop.hpAprRangesV4.length > 0) {
                            const bracket = prop.hpAprRangesV4.find(r => r.minFinanceAmount <= actualLoanAmount && r.maxFinanceAmount >= actualLoanAmount);
                            if (bracket && (bracket.apr || bracket.flatRate)) {
                                if (bracket.apr) {
                                    prop.apr = Number(bracket.apr)
                                }
                                if (bracket.flatRate) {
                                    prop.flatRate = Number(bracket.flatRate)
                                }

                                // Broker commission
                                if (bracket.commissionPercentage) {
                                    if (prop.commissionInfo == null) { prop.commissionInfo = {}; }
                                    prop.commissionInfo.commissionPercentage = Number(bracket.commissionPercentage);
                                }
                                if (bracket.commissionFixed) {
                                    if (prop.commissionInfo == null) { prop.commissionInfo = {}; }
                                    prop.commissionInfo.commissionFixed = Number(bracket.commissionFixed);
                                }

                                // Affiliate commission (dealer introduced apps)
                                if (bracket.affiliateCommissionPercentage) {
                                    if (prop.affiliateCommissionInfo == null) { prop.affiliateCommissionInfo = {}; }
                                    prop.affiliateCommissionInfo.commissionPercentage = Number(bracket.affiliateCommissionPercentage);
                                }
                                if (bracket.affiliateCommissionFixed) {
                                    if (prop.affiliateCommissionInfo == null) { prop.affiliateCommissionInfo = {}; }
                                    prop.affiliateCommissionInfo.commissionFixed = Number(bracket.affiliateCommissionFixed);
                                }
                            }
                        }
                    }

                    //Moneyway offers lower rates to my customers if they pay a deposit of 5% or greater
                    if (prop.financeCompanyId === MONEYWAY) {
                        if (prop.flatRateByDepositPercentage) {
                            const depositPercentage = getNum(deposit) / (vehicle.price + extrasInPrice + extrasOutPrice) * 100;

                            if (depositPercentage >= prop.flatRateByDepositPercentage.minDepositPercentage) {
                                prop.flatRate = prop.flatRateByDepositPercentage.reducedFlatRate;
                            } //else deposit is too low, reduced flat rate is not applicable.
                            else {
                                prop.flatRate = prop.flatRateByDepositPercentage.originalFlatRate;
                            }
                        }
                    }

                    // Dealer bespoke rate overrides
                    if (options.bespokeRates) {
                        if (Array.isArray(options.bespokeRates) && options.bespokeRates.length > 0) {
                            const rateOverride = options.bespokeRates.find(r => r.financeCompanyId === prop.financeCompanyId);
                            if (rateOverride && rateOverride.rate) {
                                prop.apr = Number(rateOverride.rate)
                            }
                        }
                    }

                    if (qualifies || qualifiesPCP) {

                        if (getNum(prop.apr) > 0.0) {
                            // console.log('Calculating Monthly Payment from Apr', prop.financeCompany, prop.apr, term, loanAmount);
                            Object.assign(vprice, calculateMonthlyPayment(vehicle.price + extrasInPrice + extrasOutPrice, getNum(prop.apr), getNum(term), getNum(deposit), prop));
                        } else {

                            // Getting complex, note that bisect (== ADVANTAGE) also affects rounding
                            Object.assign(vprice,
                                calculateMonthlyPaymentFlat(vehicle.price + extrasInPrice + extrasOutPrice,
                                    getNum(prop.flatRate),
                                    getNum(term),
                                    getNum(deposit),
                                    prop
                                ));
                        }

                        vprice.deposit = getNum(deposit);
                        vprice.depositDisplay = getNum(deposit) - getNum(pxValue) + getNum(pxSettlement);
                        vprice.pxValue = pxValue;
                        vprice.pxSettlement = pxSettlement;
                        vprice.effectiveDeposit = effectiveDeposit;
                        vprice.depositRequired = depositRequired;
                        vprice.maxLTV = maxLTV;


                        if (prop.commissionInfo) {
                            if (getNum(prop.commissionInfo.commissionFixed) > 0) {
                                vprice.commissionAmount = getNum(prop.commissionInfo.commissionFixed)
                            }
                            else if (getNum(prop.commissionInfo.commissionPercentage) > 0) {
                                let commissionCap = getNum(prop.commissionInfo.commissionCap) > 0 ? getNum(prop.commissionInfo.commissionCap) : 999999;
                                let commissionCapOfInterestCharges = getNum(prop.commissionInfo.commissionPercentageCapOfTotalInterestCharges) > 0
                                    ? (vprice.totalAmountPayable - vprice.amountToFinance) * getNum(prop.commissionInfo.commissionPercentageCapOfTotalInterestCharges) / 100
                                    : 999999;
                                let commission = getNum(prop.commissionInfo.commissionPercentage) / 100 * vprice.amountToFinance;

                                vprice.commissionAmount = Math.min(commission, commissionCap, commissionCapOfInterestCharges);
                                vprice.commissionAmount = Math.round(vprice.commissionAmount * 100) / 100;
                            }
                        }

                        if (prop.affiliateCommissionInfo) {
                            if (getNum(prop.affiliateCommissionInfo.commissionFixed) > 0) {
                                vprice.affiliateCommissionAmount = getNum(prop.affiliateCommissionInfo.commissionFixed)
                            }
                            else if (getNum(prop.affiliateCommissionInfo.commissionPercentage) > 0) {
                                let commissionCap = getNum(prop.affiliateCommissionInfo.commissionCap) > 0 ? getNum(prop.affiliateCommissionInfo.commissionCap) : 999999;
                                let commission = getNum(prop.affiliateCommissionInfo.commissionPercentage) / 100 * vprice.amountToFinance;

                                vprice.affiliateCommissionAmount = Math.min(commission, commissionCap);
                                vprice.affiliateCommissionAmount = Math.round(vprice.affiliateCommissionAmount * 100) / 100;
                            }
                        }

                        // pcpQualified(vehicle, loanAmount, term) &&
                        if (qualifiesPCP && pcpLender && (!options.ignorePcpLender || !options.ignorePcpLender.find(l => l === prop.financeCompanyId))) {
                            vpricePCP.deposit = getNum(depositPCP);
                            vpricePCP.depositDisplay = getNum(depositPCP) - getNum(pxValue) + getNum(pxSettlement);
                            vpricePCP.pxValue = pxValue;
                            vpricePCP.pxSettlement = pxSettlement;
                            vpricePCP.effectiveDeposit = effectiveDeposit;
                            vpricePCP.depositRequired = depositRequiredPCP;
                            vpricePCP.maxLTV = maxLTVPCP;

                            let mpPCP = maxPricePCP ? maxPricePCP : maxPrice;

                            vpricePCP.maxDeposit = mpPCP - prop.minLendAmount;

                            if ((vehicle.price + extrasInPricePCP) > mpPCP) {
                                vpricePCP.minDeposit = (vehicle.price + extrasInPricePCP) - mpPCP;
                            }

                            if (vpricePCP.minDeposit > 0) {
                                vpricePCP.depositRequired = true;
                            }

                            if (effectiveDeposit < vpricePCP.minDeposit) {
                                vpricePCP.deposit = vpricePCP.minDeposit;
                            }

                            Object.assign(vpricePCP, calculatePcpMonthlyPayment(vehicle, vehicle.price + extrasInPricePCP + extrasOutPricePCP, term, vpricePCP.deposit, prop.apr, prop, 8000, customer));

                            // Add onto vehicle so we can show both in search results ..
                            if (vpricePCP && vpricePCP.monthlyPayment > 0) {
                                vprice.pcp = vpricePCP;
                            }
                        }
                        // ("[PCP] Vehicle Does not qualify", term, loanAmount);
                        // calculate rank based on finance amount, including extras in and out price
                        vprice.rank = getHpRank(loanAmount + extrasOutPrice, prop);

                        vprices.push(vprice);
                    } else {
                        if (prop.financeCompanyId == BNP || true) {
                            //console.log("vehicle did not pass", prop.minLendAmount, prop.maxLendAmount, prop.financeCompany, actualLoanAmount);
                        }
                    }
                } else {
                    // console.log('No rate or term for proposal', hasRate, hasTerm, prop);
                    // eslint-disable-next-line no-lonely-if
                    if ((prop.financeCompanyId === CARFINANCE247) ||
                        pcpLender) {

                        const hpApr = getPrimeRate(loanAmount, vehicleAgeInMonths(vehicle), customer, options.bespokeRates, prop.financeCompanyId, false);

                        // calculate rank based on finance amount, including extras in and out price
                        vprice.rank = getHpRank(loanAmount + extrasOutPrice, prop);

                        // calculate rank based on finance amount, including extras in and out price
                        vprice.rank = getHpRank(loanAmount + extrasOutPrice, prop);
                        const qualifies = vehicleQualifies(prop, vehicle, loanAmount, term, options, deposit, false);
                        const qualifiesPCP = vehicleQualifies(prop, vehicle, loanAmountPCP, term, options, deposit, true);

                        if (qualifies) {
                            Object.assign(vprice, calculateMonthlyPayment(vehicle.price + extrasInPrice, getNum(hpApr), getNum(term), getNum(deposit), prop));

                            vprice.deposit = getNum(deposit);
                            vprice.depositDisplay = getNum(deposit) - getNum(pxValue) + getNum(pxSettlement);
                            vprice.pxValue = pxValue;
                            vprice.pxSettlement = pxSettlement;
                            vprice.effectiveDeposit = effectiveDeposit;
                            vprice.depositRequired = depositRequired;
                            vprice.maxLTV = maxLTV;

                            if (qualifiesPCP && (!options.ignorePcpLender || !options.ignorePcpLender.find(l => l === prop.financeCompanyId))) {
                                vpricePCP.deposit = getNum(depositPCP);
                                vpricePCP.depositDisplay = getNum(depositPCP) - getNum(pxValue) + getNum(pxSettlement);
                                vpricePCP.pxValue = pxValue;
                                vpricePCP.pxSettlement = pxSettlement;
                                vpricePCP.effectiveDeposit = effectiveDeposit;
                                vpricePCP.depositRequired = depositRequiredPCP;
                                vpricePCP.maxLTV = maxLTVPCP;

                                let mpPCP = maxPricePCP ? maxPricePCP : maxPrice;

                                vpricePCP.maxDeposit = mpPCP - prop.minLendAmount;


                                if ((vehicle.price + extrasInPrice) > mpPCP) {
                                    vpricePCP.minDeposit = (vehicle.price + extrasInPrice) - mpPCP;
                                }

                                if (vpricePCP.minDeposit > 0) {
                                    vpricePCP.depositRequired = true;
                                }

                                if (effectiveDeposit < vpricePCP.minDeposit) {
                                    vpricePCP.deposit = vpricePCP.minDeposit;
                                }

                                const isCf247 = prop.financeCompanyId === CARFINANCE247;
                                const hasActualPcpLender = activeProposals.find(x => x.financeCompanyId !== CARFINANCE247);

                                if (!isCf247 || (isCf247 && !hasActualPcpLender)) {
                                    Object.assign(vpricePCP, calculatePcpMonthlyPayment(vehicle, vehicle.price + extrasInPrice + extrasOutPrice, term, vpricePCP.deposit, 0, prop, 8000, customer, options.bespokeRates));
                                }

                                // Add onto vehicle so we can show both in search results ..
                                if (vpricePCP && vpricePCP.monthlyPayment > 0) {
                                    vprice.pcp = vpricePCP;
                                }
                            } else {
                                // console.log('Vehicle does not qualify for PCP', vehicle, loanAmount, term);
                            }

                            vprices.push(vprice);
                        } // hpQualified
                    } else {
                        // console.log('Invalid proposal', prop);
                    }
                }
            } // end for filtered proposals

            // Find the "min" at this term and add to the return value array
            if (vprices.length > 0) {
                const allpcp = vprices.filter(v => v.pcp && v.pcp !== null).map(p => p.pcp).sort((a, b) => a.effectiveRate - b.effectiveRate).sort(priceSortingFunction);

                // Now, pick the best and add to the array of "prices"
                let mps = vprices.filter(x => x.minDeposit <= effectiveDeposit).sort(priceSortingFunction);

                // console.log('Sorted', mps);

                const bestRates = vprices.sort((a, b) => a.effectiveRate - b.effectiveRate).sort(priceSortingFunction);

                if (mps.length === 0) {
                    mps = vprices.sort((a, b) => a.minDeposit - b.minDeposit).sort(priceSortingFunction);
                }

                // First is best
                const bestProduct = mps[0];

                // if( bestQualifying.flatRate > 0.0 ) {
                //  bestQualifying.effectiveRate = calculateEffectiveRate(getNum(vehicle.price) - getNum(customerDeposit), v.flatRate, v.monthlyPayment, v.term);
                // }

                // Alternative Options for the same term (NOTE, Optionally filter out where rate is worse)
                bestProduct.altOptions = collapse(bestRates.filter(x => x.financeCompanyId !== bestProduct.financeCompanyId && x.effectiveRate <= bestProduct.effectiveRate));

                // CRM2-2446
                //bestProduct.otherOptions = collapse(bestRates.filter(x => x.financeCompanyId !== bestProduct.financeCompanyId && x.effectiveRate > bestProduct.effectiveRate));

                bestProduct.otherOptions = collapse(bestRates.filter(x => x.financeCompanyId !== bestProduct.financeCompanyId));

                bestProduct.otherOptions.sort(priceSortingFunction);

                minPrices.push(bestProduct);

                //pcp

                if (allpcp.length > 0) {
                    // Now, pick the best and add to the array of "prices"
                    let pmps = allpcp.filter(x => x.minDeposit <= effectiveDeposit).sort(priceSortingFunction);

                    // console.log('Sorted', mps);

                    const pcpBestRates = allpcp.sort((a, b) => a.effectiveRate - b.effectiveRate).sort(priceSortingFunction);

                    if (pmps.length === 0) {
                        pmps = allpcp.sort((a, b) => a.minDeposit - b.minDeposit).sort(priceSortingFunction);
                    }

                    // First is best
                    const bestProductPcp = pmps[0];

                    // if( bestQualifying.flatRate > 0.0 ) {
                    //  bestQualifying.effectiveRate = calculateEffectiveRate(getNum(vehicle.price) - getNum(customerDeposit), v.flatRate, v.monthlyPayment, v.term);
                    // }

                    // Alternative Options for the same term (NOTE, Optionally filter out where rate is worse)
                    bestProductPcp.altOptions = collapse(pcpBestRates.filter(x => x.financeCompanyId !== bestProductPcp.financeCompanyId && x.effectiveRate <= bestProductPcp.effectiveRate));

                    // CRM2-2446
                    //bestProduct.otherOptions = collapse(bestRates.filter(x => x.financeCompanyId !== bestProduct.financeCompanyId && x.effectiveRate > bestProduct.effectiveRate));

                    bestProductPcp.otherOptions = collapse(pcpBestRates.filter(x => x.financeCompanyId !== bestProductPcp.financeCompanyId));

                    bestProductPcp.otherOptions.sort(priceSortingFunction);

                    pcpPrices.push(bestProductPcp);
                }
            }
        } // end for term

        if (minPrices.length > 0) {
            // Now, pick the best and add to the array of "prices" - whoever is at the top
            minPrices = minPrices.sort((a, b) => a.monthlyPayment - b.monthlyPayment);

            vehicle = Object.assign(vehicle, minPrices[0]);

            // Add price Matrix to the vehicle and PCP options and sort by term
            vehicle.priceMatrix = minPrices.sort((a, b) => a.term - b.term);
            vehicle.pcpMatrix = pcpPrices.sort((a, b) => a.term - b.term);

            // Now, add other terms to altOptions for each of the minPrices - double
            // layer loop - to see if there is an acceptance with a better rate elsewhere
            // in the terms ..
            // eslint-disable-next-line no-restricted-syntax
            for (const vp1 of vehicle.priceMatrix) {
                // eslint-disable-next-line no-restricted-syntax
                for (const vp2 of vehicle.priceMatrix) {
                    // Only look across different terms, and where we are not best rate already
                    if (vp2.term !== vp1.term) {
                        // Check the headline price
                        vp1.altOptions = findBetterEffectiveRates([vp2], vp1.altOptions, vp1.financeCompanyId, vp1.effectiveRate, vp1.term);

                        // And scan all alternative options at other terms.
                        vp1.altOptions = findBetterEffectiveRates(vp2.altOptions, vp1.altOptions, vp1.financeCompanyId, vp1.effectiveRate, vp1.term);

                        // Sort by rate
                        vp1.altOptions.sort((x, y) => x.effectiveRate - y.effectiveRate);
                    }
                }
            }
        } else {
            vehicle.cannotPrice = true;
        }
    } else {
        vehicle.cannotPrice = true;
    }

    if (vehicle.cannotPrice) {
        vehicle.cannotPriceReason = cannotPriceReason(vehicle, activeProposals);
        vehicle.cannotPriceReasonPcp = vehicle.cannotPriceReason;
    }

    if (!vehicle.cannotPrice && (!vehicle.pcpMatrix || vehicle.pcpMatrix.length === 0)) {
        vehicle.cannotPricePCP = true;
        vehicle.cannotPriceReasonPCP = cannotPriceReasonPCP(vehicle, activeProposals, options.annualMileage)
    }

    vehicle.lenderDecisions = constructLenderDecisions(vehicle, activeProposals, options.bespokeRates);

    return vehicle;
};

function cannotPriceReason(vehicle, props, pcp = false) {
    let ps = Object.assign({}, props);

    if (pcp) {
        ps = ps.filter(p => PCP_LENDERS.includes(p.financeCompanyId))
        if (ps.length === 0) {
            return "No PCP approvals"
        }
    }

    const maxAge = props.filter(p => p.maxVehicleAgeAtStart).sort((a, b) => (a.maxVehicleAgeAtStart > 15 ? a.maxVehicleAgeAtStart : a.maxVehicleAgeAtStart * 12) < (b.maxVehicleAgeAtStart > 15 ? b.maxVehicleAgeAtStart : b.maxVehicleAgeAtStart * 12) ? 1 : -1);
    if (maxAge.length > 0 && vehicleAgeInMonths(vehicle) > (maxAge[0].maxVehicleAgeAtStart > 15 ? maxAge[0].maxVehicleAgeAtStart : maxAge[0].maxVehicleAgeAtStart * 12)) {
        return "Max Age"
    }

    if (props.find(p => p.vehicleRuleResults && p.vehicleRuleResults.find(r => r.message === "Vehicle age at end of term"))) {
        return "Max age at end"
    }

    const maxMiles = props
        .filter((p) => ProposalHelper.getPropMaxMileage(p, vehicle))
        .sort((a, b) => ProposalHelper.getPropMaxMileage(a, vehicle) < ProposalHelper.getPropMaxMileage(b, vehicle) ? 1 : -1);

    if (maxMiles.length > 0 && vehicle.mileage > ProposalHelper.getPropMaxMileage(maxMiles[0], vehicle)) {
        return "Max Mileage"
    }

    const minLend = props.filter(p => p.minLendAmount).sort((a, b) => a.minLendAmount < b.minLendAmount ? -1 : 1);
    if (minLend.length > 0 && vehicle.price < minLend[0].minLendAmount) {
        return "Min Lend"
    }

    const maxLend = props.filter(p => p.maxLendAmount).sort((a, b) => a.maxLendAmount < b.maxLendAmount ? 1 : -1);
    if (maxLend.length > 0 && vehicle.price > maxLend[0].maxLendAmount) {
        return "Max Lend"
    }

    if (props.find(p => p.vehicleRuleResults && p.vehicleRuleResults.find(r => r.message === "Vehicle is excluded"))) {
        return "Vehicle is excluded"
    }

    const propFailingVehicleType = props.find(p => p.vehicleRuleResults && p.vehicleRuleResults.find(r => r.message.includes("Vehicle type")));
    if (propFailingVehicleType) {
        return propFailingVehicleType.vehicleRuleResults.find(r => r.message.includes("Vehicle type")).message;
    }
    const propFailingPxPlusDeposit = props.find(p => p.vehicleRuleResults && p.vehicleRuleResults.find(r => r.rule === "DepositRule"));
    if (propFailingPxPlusDeposit) {
        return propFailingPxPlusDeposit.vehicleRuleResults.find(r => r.rule === "DepositRule").message;
    }

    return "Failed Rule";
}

function cannotPriceReasonPCP(vehicle, activeProposals) {

    if (vehicleAgeInMonths(vehicle) > 96) {
        return "Max Age"
    }

    if (vehicle.mileage > 80000) {
        return "Max Mileage"
    }

    if (vehicle.price < 2500) {
        return "Min Lend"
    }

    if (vehicle.price > 1000000) {
        return "Max Lend"
    }

    if (!activeProposals.find(p => PCP_LENDERS.includes(p.financeCompanyId))) {
        return "No PCP approvals"
    }

    if (vehicle.cannotPriceReasons && vehicle.cannotPriceReasons.find(r => r.reason === "Exceeds max annual mileage")) {
        return "Exceeds max annual mileage";
    }

    if (!vehicle.futures && !activeProposals.find(p => p.financeCompanyId === CARFINANCE247)) {
        return "No residual values"
    }

    const propFailingPxPlusDeposit = activeProposals.find(p => p.vehicleRuleResults && p.vehicleRuleResults.find(r => r.rule === "DepositRule"));
    if (propFailingPxPlusDeposit) {
        return propFailingPxPlusDeposit.vehicleRuleResults.find(r => r.rule === "DepositRule").message;
    }

    return "Failed Rule";
}

function constructLenderDecisions(vehicle, availableProposals, bespokeRates) {
    const ss = [];

    const approved = approvedLenders(vehicle, bespokeRates);
    const processing = processingLenders(availableProposals);
    const cFail = customerFailed(availableProposals);
    const declined = declinedLenders(availableProposals);
    const vFail = vehicleFailed(availableProposals, vehicle, approved, cFail, declined, processing);
    const fFail = financeFailed(availableProposals, vehicle, approved, cFail, declined, processing, vFail);

    ss.push({
        name: "Approved",
        rows: approved && approved.length > 0 ? approved.sort((a, b) => a.rate < b.rate ? -1 : 1) : approved,
        defaultOpened: true
    })

    ss.push({
        name: "Awaiting Decision",
        rows: processing,
        defaultOpened: true,
        loading: true
    })

    ss.push({
        name: "Failed Lender Vehicle Rules",
        rows: vFail,
        defaultOpened: false
    })

    ss.push({
        name: "Failed Lender Customer Rules",
        rows: cFail,
        defaultOpened: false
    })

    ss.push({
        name: "Declined",
        rows: declined,
        defaultOpened: false
    })

    ss.push({
        name: "Failed Lender Finance Rules",
        rows: fFail,
        defaultOpened: false
    })

    return ss;
}

function approvedLenders(vehicle, bespokeRates) {
    const all = [];

    if (vehicle.priceMatrix) {
        vehicle.priceMatrix.forEach(p => {
            if (all.findIndex(i => i.id === p.financeCompanyId) === -1) {
                all.push({
                    id: p.financeCompanyId,
                    icon: "mdi-check-bold",
                    iconColour: "positive",
                    title: p.financeCompany + (p.loanProposalStatus && p.loanProposalStatus === 'ProvisionalAcceptance' ? ' (Predicted)' : ''),
                    subtext: decisionRateLabel(bespokeRates, p.financeCompanyId, p.effectiveRate),
                    rate: decisionRate(bespokeRates, p.financeCompanyId, p.effectiveRate),
                })
            }
        })
    }
    if (vehicle.pcpMatrix) {
        vehicle.pcpMatrix.forEach(p => {
            if (all.findIndex(i => i.id === p.financeCompanyId) === -1) {
                all.push({
                    id: p.financeCompanyId,
                    icon: "mdi-check-bold",
                    iconColour: "positive",
                    title: p.financeCompany + (p.loanProposalStatus && p.loanProposalStatus === 'ProvisionalAcceptance' ? ' (Predicted)' : ''),
                    subtext: decisionRateLabel(bespokeRates, p.financeCompanyId, p.effectiveRate),
                    rate: decisionRate(bespokeRates, p.financeCompanyId, p.effectiveRate),
                })
            }
        })
    }
    if (vehicle.priceMatrix) {
        vehicle.priceMatrix.forEach(p => {
            p.altOptions.forEach(a => {
                if (all.findIndex(i => i.id === a.financeCompanyId) === -1) {
                    all.push({
                        id: a.financeCompanyId,
                        icon: "mdi-check-bold",
                        iconColour: "positive",
                        title: a.financeCompany + (a.loanProposalStatus && a.loanProposalStatus === 'ProvisionalAcceptance' ? ' (Predicted)' : ''),
                        subtext: decisionRateLabel(bespokeRates, a.financeCompanyId, a.effectiveRate),
                        rate: decisionRate(bespokeRates, a.financeCompanyId, a.effectiveRate)
                    })
                }
            })
            p.otherOptions.forEach(a => {
                if (all.findIndex(i => i.id === a.financeCompanyId) === -1) {
                    all.push({
                        id: a.financeCompanyId,
                        icon: "mdi-check-bold",
                        iconColour: "positive",
                        title: a.financeCompany + (a.loanProposalStatus && a.loanProposalStatus === 'ProvisionalAcceptance' ? ' (Predicted)' : ''),
                        subtext: decisionRateLabel(bespokeRates, a.financeCompanyId, a.effectiveRate),
                        rate: decisionRate(bespokeRates, a.financeCompanyId, a.effectiveRate)
                    })
                }
            })
        })
    }
    if (vehicle.pcpMatrix) {
        vehicle.pcpMatrix.forEach(p => {
            p.altOptions.forEach(a => {
                if (all.findIndex(i => i.id === a.financeCompanyId) === -1) {
                    all.push({
                        id: a.financeCompanyId,
                        icon: "mdi-check-bold",
                        iconColour: "positive",
                        title: a.financeCompany + (a.loanProposalStatus && a.loanProposalStatus === 'ProvisionalAcceptance' ? ' (Predicted)' : ''),
                        subtext: decisionRateLabel(bespokeRates, a.financeCompanyId, a.effectiveRate),
                        rate: decisionRate(bespokeRates, a.financeCompanyId, a.effectiveRate)
                    })
                }
            })
            p.otherOptions.forEach(a => {
                if (all.findIndex(i => i.id === a.financeCompanyId) === -1) {
                    all.push({
                        id: a.financeCompanyId,
                        icon: "mdi-check-bold",
                        iconColour: "positive",
                        title: a.financeCompany + (a.loanProposalStatus && a.loanProposalStatus === 'ProvisionalAcceptance' ? ' (Predicted)' : ''),
                        subtext: decisionRateLabel(bespokeRates, a.financeCompanyId, a.effectiveRate),
                        rate: decisionRate(bespokeRates, a.financeCompanyId, a.effectiveRate)
                    })
                }
            })
        })
    }

    return all;
}

function declinedLenders(availableProposals) {
    const dec = [];

    availableProposals.forEach(p => {
        if (p.loanProposalStatus && p.loanProposalStatus.toString() === 'Declined' && !dec.find(d => d.id === p.financeCompanyId)) {
            dec.push({
                id: p.financeCompanyId,
                title: p.financeCompany,
                icon: "mdi-close-thick",
                iconColour: "negative",
                subtext: null
            })
        }
    })

    return dec;
}

function processingLenders(availableProposals) {
    const dec = [];

    availableProposals.forEach(p => {
        if (p.loanProposalStatus && p.loanProposalStatus.toString() === 'Processing' && !dec.find(d => d.id === p.financeCompanyId)) {
            dec.push({
                id: p.financeCompanyId,
                title: p.financeCompany,
                icon: "mdi-loading",
                iconColour: "warning",
                subtext: null
            })
        }
    })

    return dec;
}

function customerFailed(availableProposals) {
    const dec = [];

    availableProposals.forEach(p => {
        if (!dec.find(d => d.id === p.financeCompanyId) &&
            ((p.loanProposalStatus && p.loanProposalStatus.toString() !== 'Accepted') &&
                p.customerRuleResults && p.customerRuleResults.find(r => r.resultType === 'FixedDecline')) ||
            (p.loanProposalStatus && p.loanProposalStatus === 'FailedSendRules')) {
            dec.push({
                id: p.financeCompanyId,
                title: p.financeCompany,
                icon: "mdi-exclamation-thick",
                iconColour: "negative",
                subtext: p.loanProposalStatus && p.loanProposalStatus === 'FailedSendRules' ? 'Failed send rules' : p.customerRuleResults.find(r => r.resultType === 'FixedDecline').message
            })
        }
    })

    return dec;
}

function vehicleFailed(availableProposals, vehicle, approved, customerFailed, declined, processing) {
    const vf = [];

    availableProposals.filter(p => !processing.find(a => a.id === p.financeCompanyId))
        .forEach(p => {
            // we wanna get all fail rules for lender so get all props by lender a lender id
            let sm = availableProposals.filter(a => a.financeCompanyId === p.financeCompanyId).sort((a, b) => a.minLendAmount - b.minLendAmount)

            // if there is a fail rule for lender and we havent already added it to the list
            if (sm.find(i => i.vehicleRuleResults.filter(r => r.resultType === "VehicleFailRule" && r.vehicleId === vehicle.vehicleId))
                && !vf.find(d => d.id === p.financeCompanyId)) {

                // get all the fail rules for the vehicle
                const ls = sm.map(s => [...new Set(s.vehicleRuleResults.filter(r => r.resultType === "VehicleFailRule"))])
                let bs = [];
                ls.forEach(l => bs.push(...l));
                bs = bs.sort((a, b) => a.displayPriority - b.displayPriority)

                bs.forEach(d => {
                    if (!vf.find(a => a.id === d.id)) {
                        vf.push({
                            id: p.financeCompanyId,
                            title: p.financeCompany,
                            pcp: d.pcp,
                            icon: "mdi-exclamation-thick",
                            iconColour: "warning",
                            subtext: d.message
                        })
                    }
                })
            }
        })

    return vf;
}

function financeFailed(availableProposals, vehicle, approved, customerFailed, declined, processing, vehicleFailed) {
    const ffail = [];

    availableProposals.filter(p =>
        !customerFailed.find(a => a.id === p.financeCompanyId) &&
        !vehicleFailed.find(a => a.id === p.financeCompanyId) &&
        !declined.find(a => a.id === p.financeCompanyId) &&
        !processing.find(a => a.id === p.financeCompanyId))
        .forEach(p => {
            let sm = availableProposals.filter(a => a.financeCompanyId === p.financeCompanyId).sort((a, b) => a.minLendAmount - b.minLendAmount)

            if (!sm.find(i => i.vehicleRuleResults.filter(r => r.resultType === "FinanceFailRule" && r.vehicleId === vehicle.vehicleId).length === 0)) {

                const ls = sm.map(s => [...new Set(s.vehicleRuleResults.filter(r => r.resultType === "FinanceFailRule"))])
                let bs = [];
                ls.forEach(l => bs.push(...l));
                bs = bs.sort((a, b) => a.displayPriority - b.displayPriority)
                bs.forEach(d => {
                    if (!ffail.find(a => a.term === d.term && a.pcp === d.pcp && a.id === p.financeCompanyId)) {
                        ffail.push({
                            id: p.financeCompanyId,
                            title: p.financeCompany,
                            term: d.term,
                            pcp: d.pcp,
                            icon: "mdi-exclamation-thick",
                            iconColour: "warning",
                            subtext: d.message
                        })
                    }
                })
            }
        })

    return ffail;
}

function decisionRateLabel(bespokeRates, id, effectiveRate) {
    return bespokeRates && bespokeRates.find(b => b.financeCompanyId === id) ? (bespokeRates.find(b => b.financeCompanyId === id).rate + "% APR (Bespoke)") : (effectiveRate + "% APR")
}

function decisionRate(bespokeRates, id, effectiveRate) {
    return bespokeRates && bespokeRates.find(b => b.financeCompanyId === id) ? bespokeRates.find(b => b.financeCompanyId === id).rate : effectiveRate
}

function getHpRank(loanAmount, proposal) {
    if (proposal.hpRank && proposal.hpRank.length > 0) {
        const bracket = proposal.hpRank.find(r => r.minFinanceAmount <= loanAmount && r.maxFinanceAmount >= loanAmount);
        return bracket ? bracket.rank : proposal.rank ? proposal.rank : 0
    }
    return proposal.rank ? proposal.rank : 0;
}

function mockProposal(price, apr, months) {
    const proposal = {};

    proposal.applicationId = Number(100101010);
    proposal.proposalKey = null;
    proposal.proposalId = Number(10101);
    proposal.lenderReference = 'DUMMY_REF';
    proposal.isPrime = false;
    proposal.isPreferredAcceptance = true;
    proposal.minVehicleAgeAtStart = null;
    proposal.maxVehicleAgeAtStart = null;
    proposal.minMileage = null;
    proposal.maxMileage = Number(120000);
    proposal.maxLendAmount = Number(50000);
    proposal.minLendAmount = Number(2500);
    proposal.minTerm = Number(24);
    proposal.maxTerm = Number(60);
    proposal.customerUserId = Number(101010);

    proposal.amountToFinance = Number(price);
    proposal.term = Number(months);
    proposal.apr = Number(apr);
    proposal.flatRate = null;
    proposal.monthlyPayment = null;
    proposal.totalAmountPayable = null;
    proposal.financeCompany = '247 Money';
    proposal.financeCompanyId = 57;
    proposal.tierId = 0;
    proposal.createdUtc = new Date();

    return proposal;
};

function mockPrimeProposal(price, apr, months) {
    const proposal = {};

    proposal.applicationId = Number(100101010);
    proposal.proposalKey = null;
    proposal.proposalId = Number(10101);
    proposal.lenderReference = 'DUMMY_REF';
    proposal.isPrime = true;
    proposal.isPreferredAcceptance = true;
    proposal.minVehicleAgeAtStart = null;
    proposal.maxVehicleAgeAtStart = null;
    proposal.maxVehicleAgeAtEnd = 15;
    proposal.minMileage = null;
    proposal.maxMileage = Number(140000);
    proposal.maxLendAmount = Number(100000);
    proposal.minLendAmount = Number(2000);
    proposal.minTerm = Number(12);
    proposal.maxTerm = Number(60);
    proposal.customerUserId = Number(101010);

    proposal.amountToFinance = Number(price);
    proposal.term = Number(months);
    proposal.apr = null;
    proposal.flatRate = null;
    proposal.monthlyPayment = null;
    proposal.totalAmountPayable = null;
    proposal.financeCompany = 'Carfinance247';
    proposal.financeCompanyId = 49;
    proposal.createdUtc = new Date();

    return proposal;
};

/**
 * Function to generate a rep-apr quote for a given vehicle
 * @param {*} vehicle
 * @param {*} deposit
 * @param {*} pcpLimit
 * @returns
 */
function generateRepApr(vehicle, deposit = 0, pcpLimit = 20000) {
    const hp = mockProposal(vehicle.price, 19.9, 60);
    const pcp = mockPrimeProposal(vehicle.price, 12.9, 60);

    return calculateMonthlyPaymentForVehicle(vehicle, [vehicle.price >= pcpLimit ? pcp : hp], deposit, 0);
};

module.exports = {
    calculateMonthlyPayment,
    calculateMonthlyPaymentForVehicle,
    priceSortingFunction,
    calculateMonthlyPaymentFlat,
    vehicleValid,
    getFutureValue,
    getPrimeRate,
    dumpMatrix,
    calculateEffectiveRate,
    findMaxTerms,
    generateRepApr,
    mockProposal,
    isVehiclePcpEligible,
    constructResidualsRequest,
    getResiduals,
    isVehicleSupportedforProvisionalLicence
};